// extracted by mini-css-extract-plugin
export default {"departments":"DF-z","departmentHeading":"EF-z","departmentSection":"FF-z","departmentName":"GF-z","departmentLink":"HF-z","expandIcon":"IF-z"};